import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import acesso from "./services";

interface IRequestGetForgotPass {
  login: string;
  email: string;
  novaSenha?: string;
  confirmSenha?: string;
}

interface IStateForgotPass {
  status: "idle" | "loading" | "success" | "error";
  error: string | null;
  responseData: any | null;
}

const initialState: IStateForgotPass = {
  status: "idle",
  error: null,
  responseData: null,
};

export const actionGetForgotPass = createAsyncThunk<
  any,
  IRequestGetForgotPass,
  { rejectValue: string }
>("forgotPass/actionGetForgotPass", async (params, { rejectWithValue }) => {
  try {
    const data = await acesso(params);
    return data;
  } catch (err: any) {
    const errorMessage = err.message || "Falha ao processar a solicitação.";
    return rejectWithValue(errorMessage);
  }
});

const forgotPassSlice = createSlice({
  name: "forgotPass",
  initialState,
  reducers: {
    resetForgotPassState: (state) => {
      state.status = "idle";
      state.error = null;
      state.responseData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(actionGetForgotPass.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.responseData = null;
      })
      .addCase(
        actionGetForgotPass.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.status = "success";
          state.responseData = action.payload;
        }
      )
      .addCase(
        actionGetForgotPass.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.status = "error";
          state.error = action.payload || "Ocorreu um erro desconhecido.";
        }
      );
  },
});

export const { resetForgotPassState } = forgotPassSlice.actions;
export default forgotPassSlice.reducer;
